module.exports = __webpack_public_path__ + "img/firstPerson.7b1071e5.png";